import DateUtils from '@/services/utils/DateUtils';
import { I18NGetter } from '@/services/enumTranslator/I18NGetter';

export interface TimelineConfig {
  check: (date: string) => boolean;
  label: () => string;
  filterPrevious?: (date: string) => boolean;
}

export const TimelineDictionary: TimelineConfig[] = [
  {
    check: DateUtils.isToday,
    label: () => I18NGetter().useHistoryElements.TODAY
  },
  {
    check: DateUtils.isYesterday,
    label: () => I18NGetter().useHistoryElements.YESTERDAY
  },
  {
    check: DateUtils.isDayBeforeYesterday,
    label: () => I18NGetter().useHistoryElements.DAY_BEFORE_YESTERDAY
  },
  {
    check: DateUtils.isThisWeek,
    label: () => I18NGetter().useHistoryElements.LAST_WEEK,
    filterPrevious: date => !DateUtils.isToday(date) && 
      !DateUtils.isYesterday(date) && 
      !DateUtils.isDayBeforeYesterday(date)
  },
  {
    check: DateUtils.isThisMonth,
    label: () => I18NGetter().useHistoryElements.LAST_MONTH,
    filterPrevious: date => !DateUtils.isThisWeek(date)
  },
  {
    check: DateUtils.isThisYear,
    label: () => I18NGetter().useHistoryElements.LAST_YEAR,
    filterPrevious: date => !DateUtils.isThisMonth(date)
  },
  {
    check: DateUtils.isOlderThanThisYear,
    label: () => I18NGetter().useHistoryElements.OVER_A_YEAR,
    filterPrevious: date => !DateUtils.isThisYear(date)
  }
]; 